import { Route, Routes } from "react-router-dom"
import { AuthLayout } from "@/components/layouts/AuthLayout"
import { MainLayout } from "@/components/layouts/MainLayout"
import { SimpleLayout } from "@/components/layouts/SimpleLayout"
import { ProtectedRoute } from "@/features/auth/components/ProtectedRoute"
import { NotFound } from "@/pages/NotFound"
import { devRoutes, protectedRoutes, publicRoutes } from "./routeConfig"

export function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<AuthLayout />}>
        {publicRoutes.flatMap((category) =>
          category.routes.map((route) => {
            const Component = route.component
            return Component ? (
              <Route key={route.path} path={route.path} element={<Component />} />
            ) : null
          })
        )}
      </Route>

      {/* Dev Routes */}
      <Route element={<SimpleLayout />}>
        {devRoutes.flatMap((category) =>
          category.routes.map((route) => {
            const Component = route.component
            return Component ? (
              <Route key={route.path} path={route.path} element={<Component />} />
            ) : null
          })
        )}
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          {protectedRoutes.flatMap((category) =>
            category.routes.map((route) => {
              const Component = route.component
              return Component ? (
                <Route key={route.path} path={route.path} element={<Component />} />
              ) : null
            })
          )}
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
